export default __webpack_public_path__ + "static/oswald-regular-19286529c18bfb11f8021ef09c5b8932.ttf";